const REQUEST_STATUSES = {
  approved: 'approved',
  rejected: 'rejected',
  discard: 'discard',
  pending_manual: 'pending_manual',
  in_progress: 'in_progress',
  not_started: 'not_started',
}

const REQUEST_STATUS_RESOLVER = {
  not_started: 'Not started',
  approved: 'Approved',
  rejected: 'Rejected',
  discard: 'discard',
  pending_manual: 'Pending Manual Review',
  in_progress: 'In Progress',
}

const REQUEST_TYPES = {
  update: 'update_verification',
}

export { REQUEST_STATUSES, REQUEST_TYPES, REQUEST_STATUS_RESOLVER }
